<template>
  <div class="hidden lg:flex font-medium text-sm text-gray-600 mb-4">
    <div class="flex-1 px-4">Subject</div>
    <div class="w-48 px-4">Project</div>
    <div class="w-48 px-4">Provider</div>
    <div
      class="w-32 px-4 text-blue-600 hover:underline"
      @click="toggleActiveSortingOption('order_status').refreshRouteSorting()"
    >
      <FontAwesomeIcon
        v-if="isSortingOptionActive('order_status')"
        :icon="
          getSortingOptionValue('order_status') > 0 ? 'sort-alpha-down' : 'sort-alpha-down-alt'
        "
        class="mr-2"
      />

      Status
    </div>
    <div
      class="w-32 px-4 text-blue-600 hover:underline"
      @click="toggleActiveSortingOption('delivery_at').refreshRouteSorting()"
    >
      <FontAwesomeIcon
        v-if="isSortingOptionActive('delivery_at')"
        :icon="getSortingOptionValue('delivery_at') > 0 ? 'sort-alpha-down' : 'sort-alpha-down-alt'"
        class="mr-2"
      />

      Delivery at
    </div>
    <div class="w-12 mr-2" />
  </div>
</template>

<script>
import sortMixin from '@/mixins/sortMixin';

export default {
  mixins: [sortMixin],
  watch: {
    $route: 'setInitialSortingValuesFromRoute',
  },
  created() {
    this.setSortingOptions([
      'order_status',
      'delivery_at',
      'created_at',
    ]).setInitialSortingValuesFromRoute(this.$route);
  },
};
</script>
